import React from 'react';
import { DefaultTheme } from 'styled-components';

interface Props {
  theme?: DefaultTheme;
}

const IllustrationLegal: React.FC<React.PropsWithChildren<Props>> = ({
  theme,
  ...otherProps
}) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 304 304"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <g clipPath="url(#clip0_4397_10173)">
        <path stroke="#C0C2C9" d="M0 303.5L304 303.5"></path>
        <path
          fill="#F0F1F3"
          d="M35.538 165.824c-42.866 14.948-41.731 55.797-23.913 80.648 34.744 48.464 103.895 46.495 150.737 8.084s36.47-57.251 86.763-68.795c76.653-17.593 70.558-130.125-3.057-155.914-79.167-27.73-133.633 13.597-142.11 70.248-6.902 46.101-38.805 55.413-68.42 65.729z"
        ></path>
        <ellipse
          cx="42.19"
          cy="84.329"
          fill="#F0F1F3"
          rx="25.636"
          ry="25.636"
        ></ellipse>
        <ellipse
          cx="241.785"
          cy="233.786"
          fill="#F0F1F3"
          rx="20.786"
          ry="20.786"
        ></ellipse>
        <path
          stroke={theme ? theme.gray[700] : '#C0C2C9'}
          strokeWidth="2"
          d="M67 111l40 110M67 111L27 220.5M67 111v113M236 111l40 110M236 111l-40 109.5M236 111v113"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#888D9B'}
          d="M153.65 79.34h-4.28v6.91h4.28v-6.91z"
        ></path>
        <path
          fill="#222"
          d="M153.65 79.34h-4.28v6.91h4.28v-6.91z"
          opacity="0.2"
        ></path>
        <path
          fill={theme ? theme.gray[700] : '#C0C2C9'}
          d="M148.4 293.9h6.23V137.12h-6.23V293.9z"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#888D9B'}
          d="M166.7 264.48a14.758 14.758 0 00-7-12.55l-.48-8.73h-15.37l-.49 8.73a14.998 14.998 0 00-1.33 24.43l-.48 8.84h19.92l-.48-8.9a15.113 15.113 0 005.71-11.82z"
        ></path>
        <path
          fill="#fff"
          d="M159.65 252.2l-.48-9h-15.32l-.49 9h16.29z"
          opacity="0.1"
        ></path>
        <path
          fill="#222"
          d="M142.03 276.99l-.48 9.07h19.92l-.48-9.09-18.96.02z"
          opacity="0.2"
        ></path>
        <path
          fill={theme ? theme.gray[700] : '#C0C2C9'}
          d="M137.4 281.2h28.21a42.817 42.817 0 0025.46 15.8l10.23 2v4.61h-99.6V299l10.23-2a42.794 42.794 0 0025.47-15.8z"
        ></path>
        <path
          fill="#fff"
          d="M137.4 281.2h28.21a42.817 42.817 0 0025.46 15.8l10.23 2h-99.6l10.23-2a42.794 42.794 0 0025.47-15.8z"
          opacity="0.1"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#888D9B'}
          d="M156.22 107.13h-9.42v34.39h9.42v-34.39z"
        ></path>
        <path
          fill="#222"
          d="M156.22 107.13h-9.42v34.39h9.42v-34.39z"
          opacity="0.2"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#888D9B'}
          d="M153.8 80.74c.188-.358.288-.756.29-1.16a2.58 2.58 0 00-5.16 0c.004.403.1.8.28 1.16h4.59zM195 220.2c0 3 18.45 7.62 41.2 7.62 22.75 0 41.2-4.62 41.2-7.62H195z"
        ></path>
        <path
          fill="#222"
          d="M277.4 220.2c0 3-18.45 7.62-41.2 7.62-22.75 0-41.2-4.62-41.2-7.62h82.4z"
          opacity="0.2"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#888D9B'}
          d="M26 220.2c0 3 18.45 7.62 41.2 7.62 22.75 0 41.2-4.62 41.2-7.62H26z"
        ></path>
        <path
          fill="#222"
          d="M108.4 220.2c0 3-18.45 7.62-41.2 7.62-22.75 0-41.2-4.62-41.2-7.62h82.4z"
          opacity="0.2"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#888D9B'}
          d="M151.38 95.1l3.89.19c.61 0 1.33.09 2.12.17l2.53.26c.92.07 1.84.25 2.84.4 1 .15 2 .28 3.11.54l3.35.71 3.54 1c1.21.35 2.43.76 3.69 1.15 1.26.39 2.5.91 3.78 1.38 2.53 1 5.11 2.11 7.66 3.34s5.09 2.53 7.61 3.83c2.52 1.3 5 2.58 7.47 3.74a46.059 46.059 0 007.35 2.75 38.056 38.056 0 007.19 1.28c2.165.178 4.343.138 6.5-.12.5-.06 1-.17 1.44-.25l.7-.12.66-.18 1.27-.35 1.16-.44c.19-.07.37-.13.55-.21l.51-.25.95-.48c.59-.35 1.1-.71 1.58-1l1.14-1c.275-.248.533-.515.77-.8l.62-.69 2.06 1.54-.7.86c-.27.353-.564.687-.88 1l-1.33 1.23c-.55.38-1.14.84-1.82 1.28l-1.1.61-.58.32c-.2.1-.42.18-.63.27l-1.32.56c-.46.16-.94.3-1.43.46l-.75.23-.78.18c-.52.11-1.06.25-1.61.34a35.368 35.368 0 01-7.18.42 41.26 41.26 0 01-7.9-1.07 50.09 50.09 0 01-8.07-2.65c-2.62-1.11-5.22-2.31-7.78-3.51-2.56-1.2-5.1-2.39-7.62-3.46-2.52-1.07-5-2-7.46-2.9-1.23-.39-2.43-.79-3.61-1.15-1.18-.36-2.36-.66-3.5-.95l-3.34-.74-3.15-.54c-1-.2-2-.26-2.91-.38-.91-.12-1.8-.25-2.61-.27l-2.28-.14c-.7-.05-1.34-.09-2-.08h-3.89l.19-6.31z"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#888D9B'}
          d="M152.24 95.1l-3.89.19c-.6 0-1.32.09-2.11.17l-2.54.26c-.91.07-1.84.25-2.83.4-.99.15-2 .28-3.11.54l-3.35.71-3.55 1c-1.2.35-2.43.76-3.68 1.15-1.25.39-2.5.91-3.78 1.38-2.53 1-5.12 2.11-7.66 3.34s-5.1 2.53-7.62 3.83c-2.52 1.3-5 2.58-7.47 3.74a45.642 45.642 0 01-7.35 2.75 37.809 37.809 0 01-7.19 1.28 32.29 32.29 0 01-6.49-.12c-.5-.06-1-.17-1.45-.25l-.7-.12-.66-.18-1.27-.35-1.16-.44c-.18-.07-.37-.13-.55-.21l-.5-.25-1-.48c-.58-.35-1.09-.71-1.57-1l-1.15-1a7.6 7.6 0 01-.76-.8l-.62-.69-2.07 1.54.71.86c.27.353.564.687.88 1l1.32 1.23c.55.38 1.15.84 1.82 1.28l1.1.61.59.32c.2.1.41.18.62.27l1.32.56c.46.16.95.3 1.44.46l.75.23.77.18c.53.11 1.07.25 1.62.34 2.37.384 4.772.525 7.17.42a41.18 41.18 0 007.9-1.07 50.09 50.09 0 008.07-2.65c2.63-1.11 5.22-2.31 7.79-3.51 2.57-1.2 5.1-2.39 7.62-3.46 2.52-1.07 5-2 7.45-2.9 1.23-.39 2.43-.79 3.62-1.15a80.5 80.5 0 013.5-.95l3.33-.74 3.15-.62c1-.2 2-.26 2.91-.38.91-.12 1.81-.25 2.62-.27l2.28-.14c.7-.05 1.34-.09 2-.08h3.89l-.16-6.23z"
        ></path>
        <path
          fill="#fff"
          d="M151.38 95.1l3.89.19c.61 0 1.33.09 2.12.17l2.53.26c.92.07 1.84.25 2.84.4 1 .15 2 .28 3.11.54l3.35.71 3.54 1c1.21.35 2.43.76 3.69 1.15 1.26.39 2.5.91 3.78 1.38 2.53 1 5.11 2.11 7.66 3.34s5.09 2.53 7.61 3.83c2.52 1.3 5 2.58 7.47 3.74a46.059 46.059 0 007.35 2.75 38.056 38.056 0 007.19 1.28c2.165.178 4.343.138 6.5-.12.5-.06 1-.17 1.44-.25l.7-.12.66-.18 1.27-.35 1.16-.44c.19-.07.37-.13.55-.21l.51-.25.95-.48c.59-.35 1.1-.71 1.58-1l1.14-1c.275-.248.533-.515.77-.8l.62-.69 2.06 1.54-.7.86c-.27.353-.564.687-.88 1l-1.33 1.23c-.55.38-1.14.84-1.82 1.28l-1.1.61-.58.32c-.2.1-.42.18-.63.27l-1.32.56c-.46.16-.94.3-1.43.46l-.75.23-.78.18c-.52.11-1.06.25-1.61.34a35.368 35.368 0 01-7.18.42 41.26 41.26 0 01-7.9-1.07 50.09 50.09 0 01-8.07-2.65c-2.62-1.11-5.22-2.31-7.78-3.51-2.56-1.2-5.1-2.39-7.62-3.46-2.52-1.07-5-2-7.46-2.9-1.23-.39-2.43-.79-3.61-1.15-1.18-.36-2.36-.66-3.5-.95l-3.34-.74-3.15-.54c-1-.2-2-.26-2.91-.38-.91-.12-1.8-.25-2.61-.27l-2.28-.14c-.7-.05-1.34-.09-2-.08h-3.89l.19-6.31z"
          opacity="0.1"
        ></path>
        <path
          fill="#fff"
          d="M152.24 95.1l-3.89.19c-.6 0-1.32.09-2.11.17l-2.54.26c-.91.07-1.84.25-2.83.4-.99.15-2 .28-3.11.54l-3.35.71-3.55 1c-1.2.35-2.43.76-3.68 1.15-1.25.39-2.5.91-3.78 1.38-2.53 1-5.12 2.11-7.66 3.34s-5.1 2.53-7.62 3.83c-2.52 1.3-5 2.58-7.47 3.74a45.642 45.642 0 01-7.35 2.75 37.809 37.809 0 01-7.19 1.28 32.29 32.29 0 01-6.49-.12c-.5-.06-1-.17-1.45-.25l-.7-.12-.66-.18-1.27-.35-1.16-.44c-.18-.07-.37-.13-.55-.21l-.5-.25-1-.48c-.58-.35-1.09-.71-1.57-1l-1.15-1a7.6 7.6 0 01-.76-.8l-.62-.69-2.07 1.54.71.86c.27.353.564.687.88 1l1.32 1.23c.55.38 1.15.84 1.82 1.28l1.1.61.59.32c.2.1.41.18.62.27l1.32.56c.46.16.95.3 1.44.46l.75.23.77.18c.53.11 1.07.25 1.62.34 2.37.384 4.772.525 7.17.42a41.18 41.18 0 007.9-1.07 50.09 50.09 0 008.07-2.65c2.63-1.11 5.22-2.31 7.79-3.51 2.57-1.2 5.1-2.39 7.62-3.46 2.52-1.07 5-2 7.45-2.9 1.23-.39 2.43-.79 3.62-1.15a80.5 80.5 0 013.5-.95l3.33-.74 3.15-.62c1-.2 2-.26 2.91-.38.91-.12 1.81-.25 2.62-.27l2.28-.14c.7-.05 1.34-.09 2-.08h3.89l-.16-6.23z"
          opacity="0.1"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#888D9B'}
          d="M235.97 113.26a2.58 2.58 0 100-5.16 2.58 2.58 0 000 5.16zM66.82 108.1a2.582 2.582 0 00-2.542 3.077 2.583 2.583 0 002.025 2.033 2.583 2.583 0 002.651-1.095 2.583 2.583 0 00-.316-3.256 2.584 2.584 0 00-1.818-.759zM159.5 90.2a8.001 8.001 0 00-13.657-5.657A8.001 8.001 0 00143.5 90.2c0 1.667.572 3.284 1.62 4.58l.68 15.4h11.37l.68-15.4a7.23 7.23 0 001.65-4.58z"
        ></path>
        <path
          fill="#fff"
          d="M145.14 95.36h12.73a7.45 7.45 0 001.63-4.65 8.001 8.001 0 00-16 0 7.498 7.498 0 001.62 4.65h.02z"
          opacity="0.1"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4397_10173">
          <path fill="#fff" d="M0 0H304V304H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default IllustrationLegal;
